import React from 'react';
import { Box, Text } from '@mantine/core';
import { THEME_COLORS } from '../../theme/ThemeConstants';

interface CategorySelectorProps {
  name: string;
  isActive?: boolean;
  onClick?: () => void;
}

export const CategorySelector: React.FC<CategorySelectorProps> = ({ name, isActive = false, onClick }) => {
  return (
    <Box
      style={{
        padding: '12px 16px',
        backgroundColor: 'rgba(255, 255, 255, 0.04)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        borderRadius: 4,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid rgba(255, 255, 255, 0.06)',
        borderLeftWidth: isActive ? 4 : 1,
        borderLeftColor: isActive ? THEME_COLORS.accent.primary : 'rgba(255, 255, 255, 0.06)',
        marginTop: 8
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.08)';
        if (!isActive) {
          e.currentTarget.style.borderLeftWidth = '4px';
          e.currentTarget.style.borderLeftColor = THEME_COLORS.accent.primary;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.04)';
        if (!isActive) {
          e.currentTarget.style.borderLeftWidth = '1px';
          e.currentTarget.style.borderLeftColor = 'rgba(255, 255, 255, 0.06)';
        }
      }}
      onClick={onClick}
    >
      <Text size='sm' c='white' fw={isActive ? 600 : 500}>
        {name}
      </Text>
    </Box>
  );
};
